import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class PlaylistItem extends Component {
  onClick = e => {
    const { videoMeta, initSelectedVideo } = this.props;
    initSelectedVideo(e, videoMeta);
  };

  render() {
    const { videoMeta } = this.props;

    return (
      <button
        className="playlist-item pos-r d-block mb-0_5"
        aria-label={`Select video: ${videoMeta.description}`}
        onClick={this.onClick}
        type="button"
      >
        <img src={videoMeta.thumbnailUrl} alt="" className="w-100" />
        <p className="playlist-item-description m-0 px-0_25 w-100 h6 text-center text-white">{videoMeta.description}</p>
      </button>
    );
  }
}

PlaylistItem.propTypes = {
  videoMeta: PropTypes.shape({
    thumbnailUrl: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  initSelectedVideo: PropTypes.func.isRequired,
};
